<template>
  <div class="wrapper">
    <!-- home slider -->
    <at-home-banner></at-home-banner>

    <div class="container mt-5 pb-5">
      <div class="features position-relative">
        <div class="swiper text-bg-secondary text-center">
          <ClientOnly>
            <cmsBlockSimple
              v-if="typeof headerFeatures == 'object'"
              :identifier="headerFeatures.identifier"
            />
          </ClientOnly>
        </div>
        <div
          class="swiper-pagination features-swiper-pagination swiper-pagination-horizontal"
        ></div>
      </div>

      <div class="category-grid my-5 position-relative">
        <div class="swiper">
          <div
            class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 swiper-wrapper"
          >
            <div class="col" v-for="image of images.slides" :key="image.id">
              <div class="card">
                <img :src="image.media.url" class="card-img" alt="" />
                <div class="card-img-overlay">
                  <b-link :to="image.link" class="btn btn-secondary btn-xl">
                    {{ image.buttonText }}
                  </b-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="swiper-pagination category-grid-swiper-pagination swiper-pagination-horizontal"
        ></div>
        <div class="swiper-button-prev category-grid-swiper-button-prev"></div>
        <div class="swiper-button-next category-grid-swiper-button-next"></div>
      </div>
      <div class="offers my-5 py-5" v-if="inActionProducts.length">
        <h2 class="section-heading">
          <span>{{ $t("offers") }}</span>
        </h2>
        <div class="product-grid product-grid-carousel">
          <MoreProductsCarousel :products="inActionProducts" />
          <div
            class="swiper-button-prev swiper-nav-round offers-swiper-button-prev"
          ></div>
          <div
            class="swiper-button-next swiper-nav-round offers-swiper-button-next"
          ></div>
        </div>
      </div>
      <div
        class="new-products my-0 my-md-5 py-0 py-md-5"
        v-if="newInRangeProducts.length"
      >
        <h2 class="section-heading">
          <span>{{ $t("new_in") }}</span>
        </h2>
        <div class="product-grid product-grid-carousel">
          <MoreProductsCarousel :products="newInRangeProducts" />
          <div
            class="swiper-button-prev swiper-nav-round new-products-swiper-button-prev"
          ></div>
          <div
            class="swiper-button-next swiper-nav-round new-products-swiper-button-next"
          ></div>
        </div>
      </div>
    </div>
    <div class="home-about-us text-bg-secondary py-0 py-md-5">
      <div class="container">
        <div class="row">
          <div
            class="col-12 col-md-6 col-lg-4 mb-5 mb-md-0 order-1 order-md-2 align-content-center"
            v-for="(hSlide, index) in aboutHomepageSlider.slides"
            :key="index"
          >
            <img
              class="img-fluid pt-5 pt-md-0"
              :src="hSlide.optImage"
              alt="about"
            />
          </div>
          <div
            class="col-12 col-md-6 col-lg-8 pe-lg-5 pt-0 pt-md-4 pb-md-4 order-2 order-md-1 about-homepage-description pb-5 pb-md-0"
          >
            <h2
              class="text-white fs-3 fw-bold mb-4"
              v-if="aboutHomepage && aboutHomepage.title"
            >
              {{ aboutHomepage.title }}
            </h2>
            <cmsBlockSimple
              v-if="typeof aboutHomepage == 'object'"
              :identifier="aboutHomepage.identifier"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="brands mt-5 pt-5">
      <div class="container">
        <h2 class="section-heading mb-5">
          <span>{{ $t("our_brands") }}</span>
        </h2>
      </div>
      <div class="brands-logos swiper">
        <div class="swiper-wrapper d-flex align-items-center">
          <img
            class="swiper-slide"
            :src="brandData.logo"
            :alt="brandData.title"
            v-for="(brandData, index) in lists"
            :key="`bp` + index"
            @click="onclick(brandData)"
          />
        </div>
      </div>
    </div>
    <div class="container">
      <div class="branches my-5 pt-0 pt-md-5 position-relative">
        <h2 class="section-heading mb-5">
          <span>{{ $t("our_branches") }}</span>
        </h2>

        <div class="swiper">
          <div class="row swiper-wrapper justify-content-md-center">
            <div
              class="col-12 col-lg-4"
              v-for="store of stories"
              :key="store.id"
            >
              <div class="img-container" v-if="store.base_image != null">
                <img
                  :src="store.base_image.url"
                  alt=""
                  class="img-fluid rounded-1 w-100"
                />
              </div>
              <div class="branches-inner-block">
                <h3 class="fs-4 fw-normal text-black mt-5 mb-4">
                  {{ store.name }}
                  <img
                    v-if="store.country_id === 'NL'"
                    :src="imgUrl('flag-nl.png')"
                    alt="Nederlands"
                    class="ms-1"
                  />
                  <img
                    v-if="store.country_id === 'DE'"
                    :src="imgUrl('flag-de.png')"
                    alt="Germany"
                    class="ms-1"
                  />
                </h3>

                <p class="text-muted">
                  {{ store.street }}<br />
                  {{ store.postcode }} ,{{ store.city }}
                </p>

                <b-link
                  v-if="
                    store.latitude &&
                    store.longitude &&
                    store.latitude != null &&
                    store.longitude != null
                  "
                  class="fs-5 lh-lg link-primary text-decoration-none"
                  target="_blank"
                  :href="`https://www.google.com/maps/dir/?api=1&destination=${store.latitude},${store.longitude}`"
                  >Plan route ></b-link
                >

                <b-link
                  v-else
                  class="fs-5 lh-lg link-primary text-decoration-none"
                  target="_blank"
                  href="https://www.google.com/maps/dir/?api=1&destination="
                  >Plan route ></b-link
                >

                <p
                  class="border-top border-bottom border-secondary fw-medium my-3 py-2 branches-border"
                >
                  <span class="text-muted">Tel:</span>
                  <a
                    :href="'tel:' + store.phone"
                    class="link-primary text-decoration-none"
                    >{{ store.phone }}</a
                  >
                </p>

                <table class="table table-borderless align-middle mx-n2">
                  <tbody>
                    <tr
                      v-for="openingHour of store.opening_hours"
                      :key="openingHour.id"
                    >
                      <td class="text-lowercase branch-label">
                        {{ $t(openingHour.label) }}
                      </td>
                      <td
                        class="text-muted"
                        v-for="hour of openingHour.times"
                        :key="hour.id"
                      >
                        {{ hour.from }}-{{ hour.to }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div
          class="swiper-pagination branches-swiper-pagination swiper-pagination-horizontal"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import AtHomeBanner from "@/esf_antarctica_lederhosenland/core/components/home/HomeBanner.vue";
import { loadCategoryById } from "@storefront/core/data-resolver/categories";
import { Logger } from "@storefront/core/lib/logger";
import config from "@config";
import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";
SwiperCore.use([Navigation, Pagination, Autoplay]);
import { isMobile } from "mobile-device-detect";
import getImageUrl from "@/esf_antarctica_lederhosenland/helpers/getImageUrl";
import MoreProductsCarousel from "@/esf_antarctica_lederhosenland/core/components/product-detail/MoreProductsCarousel.vue";
import cmsBlockSimple from "@/esf_antarctica_lederhosenland/core/components/common/BlockSimple.vue";
import { isTablet } from "mobile-device-detect";
import { isBrowser } from "mobile-device-detect";
import ClientOnly from "vue-client-only";

export default {
  name: "Home",
  components: {
    AtHomeBanner,
    MoreProductsCarousel,
    cmsBlockSimple,
    ClientOnly,
  },
  data: () => ({
    newInRangeId: config.categories.new_in_range,
    inActionId: config.categories.in_action,
    bestSellerId: config.categories.best_seller,
    features_swiper_options: {
      slidesPerView: 1,
      loop: true,
      speed: 400,
      pagination: {
        el: ".features-swiper-pagination",
        type: "bullets",
      },
      navigation: false,
    },
    features_swiper: false,
    category_swiper_options: {
      slidesPerView: 1,
      loop: true,
      speed: 400,
      pagination: {
        el: ".category-grid-swiper-pagination",
        type: "bullets",
      },
      navigation: {
        nextEl: ".category-grid-swiper-button-next",
        prevEl: ".category-grid-swiper-button-prev",
      },
    },
    category_swiper: false,
    branches_swiper_options: {
      slidesPerView: 1,
      loop: true,
      speed: 400,
      pagination: {
        el: ".branches-swiper-pagination",
        type: "bullets",
      },
      navigation: false,
    },
    branches_swiper: false,
  }),
  computed: {
    images() {
      return this.$store.getters["sliders/getSliderByIdentifier"](
        "home_gallery"
      );
    },
    aboutHomepage() {
      return this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
        "about_homepage"
      );
    },
    headerFeatures() {
      return this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
        "header_features"
      );
    },
    aboutHomepageSlider() {
      let aboutSlider =
        this.$store.getters["sliders/getSliderByIdentifier"](
          "about_homepage"
        ) || {};
      if (aboutSlider.slides != null) {
        aboutSlider.slides.forEach((element) => {
          if (this.mobileCheck == "browser") {
            element.optImage = element.media.url;
          } else if (this.mobileCheck == "tablet") {
            element.optImage = element.media.smaller;
          } else {
            element.optImage = element.media.smallest;
          }
        });
      }
      return aboutSlider;
    },
    mobileCheck() {
      if (isBrowser) {
        return "browser";
      }
      if (isMobile && isTablet) {
        return "tablet";
      }
      return "mobile";
    },
    stories() {
      const data = this.$store.getters["stores/getStores"];
      return data;
    },

    blogs() {
      let data = [...this.$store.getters["blog/getCurrentPage"]];
      const shuffled = data.sort(() => 0.5 - Math.random());

      return shuffled.slice(0, 3);
    },

    newInRangeProducts() {
      return this.$store.getters["home/getNewInRangeProducts"];
    },

    inActionProducts() {
      return this.$store.getters["home/getInActionProducts"];
    },

    bestSellersProducts() {
      return this.$store.getters["home/getBestSellers"];
    },
    brands() {
      return this.$store.getters["product/getBrandSlider"];
    },
    lists() {
      if (this.brands.length === 0) {
        return [];
      }
      return this.brands;
    },
  },
  methods: {
    onclick(brandData) {
      if (brandData && brandData.urlKey) {
        this.$router.push("/merken/" + brandData.urlKey);
      }
    },
    imgUrl(filename) {
      return getImageUrl(filename);
    },
    async loadCategory(categoryId) {
      const category = await loadCategoryById(categoryId).catch((e) => {
        Logger.error("loadCategoryById", "category store actions load", e)();
        throw e;
      });
      this.$router.push("/" + category.url_key);
    },
    filterInstock(products) {
      return products.filter((product) => product.stock_status === "IN_STOCK");
    },
    init_slider() {
      this.brands_swiper = new Swiper(".brands .swiper", {
        grabCursor: true,
        slidesPerView: "auto",
        spaceBetween: 100,
        loop: true,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },
        freeMode: true,
        speed: 1700,
        freeModeMomentum: false,
      });

      const brandEl = document.querySelector(".brands .swiper");
      if (brandEl) {
        brandEl.addEventListener("mouseenter", () => {
          if (this.brands_swiper?.autoplay) {
            this.brands_swiper.autoplay.stop();
          }
        });
        brandEl.addEventListener("mouseleave", () => {
          if (this.brands_swiper?.autoplay) {
            this.brands_swiper.autoplay.start();
          }
        });
      }

      if (window.innerWidth <= 767) {
        if (!this.category_swiper) {
          document.querySelectorAll(".features li").forEach(function (ele) {
            ele.classList.add("swiper-slide");
          });
          this.features_swiper = new Swiper(
            ".features .swiper",
            this.features_swiper_options
          );

          document
            .querySelectorAll(".category-grid .col")
            .forEach(function (ele) {
              ele.classList.add("swiper-slide");
            });
          this.category_swiper = new Swiper(
            ".category-grid .swiper",
            this.category_swiper_options
          );
        }
      } else if (this.category_swiper.initialized) {
        this.features_swiper.destroy();
        this.features_swiper = false;
        document.querySelectorAll(".features li").forEach(function (ele) {
          ele.classList.remove("swiper-slide");
        });

        this.category_swiper.destroy();
        this.category_swiper = false;
        document
          .querySelectorAll(".category-grid .col")
          .forEach(function (ele) {
            ele.classList.remove("swiper-slide");
          });
      }

      if (window.innerWidth <= 991) {
        if (!this.branches_swiper) {
          document
            .querySelectorAll(".branches .row > div")
            .forEach(function (ele) {
              ele.classList.add("swiper-slide");
            });
          this.branches_swiper = new Swiper(
            ".branches .swiper",
            this.branches_swiper_options
          );
        }
      } else if (this.branches_swiper.initialized) {
        this.branches_swiper.destroy();
        this.branches_swiper = false;
        document
          .querySelectorAll(".branches .row > div")
          .forEach(function (ele) {
            ele.classList.remove("swiper-slide");
          });
      }
    },
    handleWindowSizeChange() {
      this.init_slider();
    },
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "title",
          content: this.cmsDefaultPageContent
            ? this.cmsDefaultPageContent.meta_title
            : "",
        },
        {
          name: "keywords",
          content: this.cmsDefaultPageContent
            ? this.cmsDefaultPageContent.meta_keywords
            : "",
        },
        {
          name: "description",
          content: this.cmsDefaultPageContent
            ? this.cmsDefaultPageContent.meta_description
            : "",
        },
      ],
      //test 3
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: "Home",
      // all titles will be injected into this template
      link: [{ rel: "canonical", href: config.app_url + this.$route.fullPath }],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.init_slider();
    });
    window.addEventListener("resize", this.handleWindowSizeChange);
  },
};
</script>

<style></style>
